import React from 'react'
import Header from '../../component/layout/header'
import { Outlet } from 'react-router'
import useNav from '../../component/custom-hooks/get-nav';

const ReportsLayout = () => {
  const navList = useNav();
  let { reportsTopHeaderNav, reportsBottomNav } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={reportsBottomNav} topTabs={reportsTopHeaderNav} />
      <Outlet />
    </div>
  )
}

export default ReportsLayout
